export const preDefinedRefurbCarStatus = {
    UNASSIGNED: "UNASSIGNED",
    ASSIGNED_INSPECTOR: "ASSIGNED_INSPECTOR",
    JOB_LIST_CREATED: "JOB_LIST_CREATED",
    REFURB_DONE: "REFURB_DONE",
};

export const getCarStatusNames = () => {
    return [{value: preDefinedRefurbCarStatus.UNASSIGNED, displayName: 'Unassigned'},
        {value: preDefinedRefurbCarStatus.ASSIGNED_INSPECTOR, displayName: 'Inspector Assigned'},
        {value: preDefinedRefurbCarStatus.JOB_LIST_CREATED, displayName: 'Job List Created'},
        {value: preDefinedRefurbCarStatus.REFURB_DONE, displayName: 'Refurb Done by all Technicians'},
        {value: 'REFURB_IN_PROGRESS', displayName: 'Refurb In Progress'}
    ];
};

export const inventoryStatusFilter = () => {
    return [
        {value: 'INSPECTOR_ASSIGNMENT_PENDING', displayName: 'Inspector Assignment Pending'},
        {value: 'INSPECTION_NOT_STARTED', displayName: 'Inspection Not Started'},
        {value: 'INSPECTION_IN_PROGRESS', displayName: 'Inspection In Progress'},
        {value: 'JOBLIST_APPROVAL_PENDING', displayName: 'Joblist Approval Pending'},
        {value: 'REFURB_IN_PROGRESS', displayName: 'Refurb In Progress'},
        {value: 'INVOICE_CREATION_PENDING', displayName: 'Invoice Creation Pending'},
        {value: 'INVOICE_CREATED', displayName: 'Invoice Created'},
        {value: 'REFURB_COMPLETED', displayName: 'Refurb Completed'},
        {value: 'SOFT_ASSIGNED', displayName: 'Soft Assigned'},
        {value: 'VALIDATION_PENDING', displayName: 'Validation Pending'},
        {value: 'BUDGET_PENDING', displayName: 'Budget Approval Pending'},
    ]
}